import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  standalone: true,
  selector: 'pm-form-field-custom-input-otp',
  imports: [InputTextModule, ReactiveFormsModule, CommonModule],
  templateUrl: './pm-form-field-custom-input-otp.component.html',
  styleUrl: './pm-form-field-custom-input-otp.component.scss',
})
export class PmFormFieldCustomInputOtpComponent
  extends FormFieldComponent
  implements AfterViewInit
{
  @Input() length = 4;
  items = computed(() => Array.from({ length: this.length }, (_, i) => i));
  @ViewChildren('inputRef') inputRef!: QueryList<ElementRef>;

  onInput($event: any, index: number) {
    const item = this.inputRef.get(index);
    if (item) {
      if (!this.checkIsNumber(item.nativeElement.value)) {
        $event.stopPropagation();
        $event.preventDefault();
        item.nativeElement.value = item?.nativeElement.value.replace(
          /[^0-9]/g,
          ''
        );
        return;
      }
    }
  }

  onInputKeyup($event: KeyboardEvent, index: number) {
    if ($event.key === 'Backspace') {
      this.mergeValues();
      const prevIndex = index - 1;
      if (prevIndex >= 0) {
        const prevEl = this.inputRef.get(prevIndex);
        if (prevEl) {
          prevEl.nativeElement.focus();
        }
      }

      return;
    }
    const item = this.inputRef.get(index);
    if (item) {
      if (item.nativeElement.value === '') return;
      if (!this.checkIsNumber(item.nativeElement.value)) {
        $event.stopPropagation();
        $event.preventDefault();
        item.nativeElement.value = item?.nativeElement.value.replace(
          /[^0-9]/g,
          ''
        );
        return;
      }
    }
    if ($event.key === 'Tab') return;

    this.mergeValues();
    const nextIndex = index + 1;
    const el = this.inputRef.get(nextIndex);
    if (!el) return;
    el.nativeElement.focus();
  }

  mergeValues() {
    let value = '';
    this.inputRef.forEach((ir) => {
      value += ir.nativeElement.value;
    });
    this.ctrl.patchValue(value);
    this.ctrl.markAsDirty();
  }

  ngAfterViewInit() {
    this.initValue();
  }

  initValue(val?: string) {
    if (!this.ctrl?.value && !val) return;
    Array.from(String(val || this.ctrl?.value)).forEach((char, index) => {
      if (!this.checkIsNumber(char)) return;
      const input = this.inputRef.get(index);
      if (!input) return;
      input.nativeElement.value = char;
    });
  }

  onPaste(event: ClipboardEvent) {
    const pastedData = event.clipboardData?.getData('text');
    if (!pastedData) return;
    this.initValue(pastedData);
    setTimeout(() => {
      const input = this.inputRef.last;
      if (!input) return;
      input.nativeElement.focus();
    });
  }

  checkIsNumber(char: string) {
    return /[0-9]/.test(char);
  }
}
